import React from 'react';
import { Drawer, Button, Grid } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import './stepDrawer.css';

// Right-hand drawer with a step bar and a sticky footer.
// steps: [{ key, title, content }]
// The parent owns `current` and decides whether "Continue" may move on.
const StepDrawer = ({
  open,
  title,
  subtitle,
  steps,
  current,
  onStepClick,
  onBack,
  onNext,
  onClose,
  footerStart,
  submitButton,
  width = 680,
}) => {
  const screens = Grid.useBreakpoint();
  const isLast = current === steps.length - 1;

  return (
    <Drawer
      open={open}
      onClose={onClose}
      width={screens.md ? width : '100%'}
      closable={false}
      destroyOnClose
      className="step-drawer"
      styles={{ body: { padding: 0, display: 'flex', flexDirection: 'column' } }}
    >
      <div className="sd-head">
        <div className="sd-title-row">
          <div className="sd-titles">
            <h2 className="sd-title">{title}</h2>
            {subtitle && <span className="sd-subtitle">{subtitle}</span>}
          </div>
          <Button type="text" aria-label="Close" icon={<CloseOutlined />} onClick={onClose} />
        </div>
        <ol className="sd-steps" style={{ gridTemplateColumns: `repeat(${steps.length}, minmax(0, 1fr))` }}>
          {steps.map((step, index) => {
            const state = index < current ? 'done' : index === current ? 'current' : 'todo';
            return (
              <li key={step.key} className={`sd-step sd-step-${state}`}>
                <span className="sd-step-bar" />
                <button
                  type="button"
                  className="sd-step-label"
                  onClick={() => onStepClick(index)}
                  aria-current={state === 'current' ? 'step' : undefined}
                >
                  {index + 1}. {step.title}
                </button>
              </li>
            );
          })}
        </ol>
      </div>

      <div className="sd-body">{steps[current]?.content}</div>

      <div className="sd-foot">
        <div className="sd-foot-start">{footerStart}</div>
        {current > 0 && <Button onClick={onBack}>Back</Button>}
        {isLast ? submitButton : (
          <Button type="primary" onClick={onNext}>
            Continue
          </Button>
        )}
      </div>
    </Drawer>
  );
};

export default StepDrawer;
